import { __ } from '@wordpress/i18n';
const sseImport = {
	complete: {
		posts: 0,
		media: 0,
		users: 0,
		comments: 0,
		terms: 0,
	},

	updateDelta: function (type, delta) {
		this.complete[type] += delta;

		var self = this;
		requestAnimationFrame(function () {
			self.render();
		});
	},

	updateProgress: function ( type, complete, total, dispatch, percentage ) {
		var text = complete + '/' + total;

		if ( 'undefined' !== type && 'undefined' !== text ) {
			total = parseInt(total, 10);
			if (0 === total || isNaN(total)) {
				total = 1;
			}

			var percent = parseInt(complete, 10) / total;
			var progress = Math.round(percent * 100) + '%';
			var progress_bar = percent * 100;

			if ( progress_bar <= 100 ) {

				if ( 'function' === typeof dispatch ) {
					dispatch({
						type: 'set',
						importStatus: __( 'Importing Content..' + text, 'astra-sites' ),
					})
					percentage += 5;
					dispatch({
						type: 'set',
						importPercent: percentage,
					})
				}

			}
		}
	},
	render: function ( dispatch, percentage ) {
		var types = Object.keys( this.complete );
		var complete = 0;
		var total = 0;

		for (var i = types.length - 1; i >= 0; i--) {
			var type = types[i];
			this.updateProgress(type, this.complete[type], this.data.count[type], dispatch, percentage);

			complete += this.complete[type];
			total += this.data.count[type];
		}

		this.updateProgress('total', complete, total, dispatch, percentage);
	}
};

export default sseImport;
